export const isValidMobile = (mobile) => {
  if (!mobile) return false;
  // Strip all non-digit characters (spaces, dashes, parentheses, +)
  const digitsOnly = mobile.replace(/\D/g, "");
  // UK mobile: starts with 07, 11 digits total
  if (/^07\d{9}$/.test(digitsOnly)) return true;
  // International: E.164-style — at least 7 digits, at most 15
  if (/^\d{7,15}$/.test(digitsOnly)) return true;
  return false;
};

export const normalizeUkMobile = (mobile) => {
  if (mobile === null || mobile === undefined) return "";

  const trimmed = String(mobile).trim();
  if (!trimmed) return "";

  const digitsOnly = trimmed.replace(/\D/g, "");
  if (/^07\d{9}$/.test(digitsOnly)) return digitsOnly;
  if (/^447\d{9}$/.test(digitsOnly)) return `0${digitsOnly.slice(2)}`;
  if (/^00447\d{9}$/.test(digitsOnly)) return `0${digitsOnly.slice(4)}`;
  if (/^7\d{9}$/.test(digitsOnly)) return `0${digitsOnly}`;

  return trimmed.replace(/\s+/g, "");
};

export const isValidLandline = (landline) =>
  false || /^\+?[1-9]\d{1,14}$$/.test(landline);
export const isValidEmail = (email) =>
  false ||
  /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email,
  );
export const isValidPostCode = (postcode) =>
  false ||
  /^[A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2}$/.test(
    postcode,
  );

export const isValidName = (name) => /^[a-zA-Z\s\-']+$/.test(name);

export const VALID_TITLES = ['MR', 'MRS', 'MS', 'MISS', 'MX'];

export const isValidTitle = (title) => VALID_TITLES.includes(title);

export const isValidDob = (dob) => {
  const parts = dob?.split('/');
  if (!parts?.length || parts.length !== 3) return false;
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);
  if (isNaN(day) || isNaN(month) || isNaN(year)) return false;
  if (year < 1900 || year > 2007) return false;
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return false;
  const today = new Date();
  const todayYear = today.getFullYear();
  if (year > todayYear) return false;
  return true;
};
